// import React from "react";

// export default function SectionHero({
//   title,
//   subtitle,
//   imageUrl,
//   overlayColor = "rgba(0, 0, 0, 0.45)", // subtle dark overlay
// }) {
//   return (
//     <section
//       className="relative w-full h-[60vh] flex items-center justify-center overflow-hidden"
//       style={{
//         backgroundImage: `url(${imageUrl})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//       }}
//     >
//       {/* Overlay */}
//       <div
//         className="absolute inset-0"
//         style={{
//           background: `linear-gradient(to right, ${overlayColor}, ${overlayColor})`,
//         }}
//       />

//       {/* Content */}
//       <div className="relative z-10 text-left px-50 max-w-3xl">
//         <h1 className="text-4xl md:text-6xl font-extrabold text-white leading-tight drop-shadow-lg">
//           {title}
//         </h1>
//         <p className="mt-6 text-lg md:text-xl text-gray-100 leading-relaxed">
//           {subtitle}
//         </p>
//       </div>
//     </section>
//   );
// }

export default function SectionHero({
    title,
    subtitle,
    imageUrl,
    overlayColor = "rgba(0, 0, 0, 0.45)",
    position = "center left", // default positioning
  }) {
    return (
      <section
        className="section-hero"
        style={{
          backgroundImage: `url(${imageUrl})`,
        }}
      >
        <div
          className="overlay"
          style={{ backgroundColor: overlayColor }}
        ></div>
  
        <div className={`hero-content ${position.replace(" ", "-")}`}>
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </div>
      </section>
    );
  }